import React, { Component } from 'react';
import { connect } from 'react-redux';

import '@/companys/ttl/assets/styles/components/instrument/market-set-dialog.scss'
import Edit from '@/companys/ttl/assets/images/icons/market_edit.png'
import topW from '@/companys/ttl/assets/images/icons/market_set_top.png'
import { Icons } from '@/configurations';
import SearchIcon from '@/assets/images/icons/nav_icon_search.png';
import WatchlistAddIcon from '@/assets/images/icons/nav_search_icon_watchlist_normal.png';
import SearchWatchlistIcon from '@/assets/images/icons/nav_search_icon_watchlist_hit.png';

import { userActions } from '@/actions/user';
import { forumActions } from '@/actions/forum';
import { utilsFunction, Converter } from '@/helpers/functions';
import { SERVICES_RESP } from '@/configurations';
import { WINVEST_PARAMS_JSON_FLAG } from '@/constants/win-vest'

import Tips from '@/components/Tips/Tips';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import Dropdown from '@/components/Dropdown/Dropdown';
import { LOADING_TYPE } from '@/constants/app';
import { openMarketWatchListConfirmDialog } from '@/actions/app';

class MarketSetDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showInput: false,
      currentGroupIndex: 0,
      currentGroup: '',
      isLoadingConfirm: false,
      errorMessage: null,
      load: true,
      currentEdit: -1,
      currentEditItem: null,
      currentMarket: '',
      showSearchBlock: false,
      searchList: [],
    }
  }
  render() {
    const { language, watchlist, markets, theme } = this.props
    const { showInput, currentGroupIndex, isLoadingConfirm, errorMessage, load, currentEdit, currentGroup, showSearchBlock, searchList } = this.state
    return (
      <div className='market-set-dialog' onClick={() => { this.setState({ showSearchBlock: false }) }} >
        <LoadingLayer type={LOADING_TYPE.BIG_IMG} load={load} />
        <div className='watchlist-group-name'>
          <div className='group-head'>
            {language.market_watchlist_group_name}
          </div>

          <div className='watchlist-name' >
            {watchlist.custom && watchlist.custom.map((item, index) => {
              return (
                <div className='single-watchlist' key={index} onClick={() => this.handleGruopSelect(index, item)} style={{ backgroundColor: currentGroupIndex == index ? theme === 'light' ? "#e3eaf2" : "#1d252e" : "" }}  >
                  {currentEdit == index ? <input className='single-watchlist-input' ref={e => this.inputEditRef = e} onClick={e => e.stopPropagation()}
                    autoFocus='autoFocus' onKeyDown={e => e.keyCode == 13 ? this.handleDocumentClick() : ''} ></input> :
                    <span className='single-watchlist-name' >{item.title}</span>}
                  <div className='single-watchlist-icon' >
                    <img src={Edit} className='swtachlist-icon-edit' onClick={(e) => this.handleEdit(e, item, index)} />
                    <div className='swtachlist-icon-delete' onClick={() => openMarketWatchListConfirmDialog(item, () => this.handleDelete(item), language.market_confirm_text ,'market_delete_confirm' )} > 
                      <Icons.WatchlistDelete />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>

          <div className='add-new-group' style={{ marginTop: showInput ? '0px' : '30px', color: showInput ? '#1780c2' : '' }}>
            <span className='ang-text' onClick={() => this.handleShowInput()} >{language.market_add_new_watchlist_group}  </span>
          </div>
          <div className='ang-group' >
            <input className='ang-input' style={{ opacity: showInput ? '1' : '0', visibility: showInput ? '' : 'hidden' }}
              placeholder={language.market_watchlist_name}
              ref={e => this.angInputRef = e}
              disabled={isLoadingConfirm ? true : false}
              onKeyDown={e => e.keyCode === 13 ? this.handleAddWatchlist() : ''}
              ></input>
            <div className='ang-button' style={{ opacity: showInput ? '1' : '0', visibility: showInput ? '' : 'hidden' }}
              onClick={isLoadingConfirm ? () => { } : () => this.handleAddWatchlist()}
            > {isLoadingConfirm ? <Icons.Loading /> : language['common_confirm']} </div>
          </div>
          <div className='ang-error' style={{margin:!showInput?"-25px 0 0 0":"0 0 0 0"}} >
            {errorMessage && <Tips isNoBgColor>{language[errorMessage] ?? errorMessage}</Tips>}
          </div>
        </div>
        {/* ////////////////////////// */}
        <div className='edit-the-stocks'>
          <div className='edit-head'>
            <div className='edit-head-stocks' >{language.market_edit_the_stocks}</div>
            <div className='edit-head-import' >
              <span className='head-import-stock'>{language.common_search_stock}</span>
              <Dropdown
                selectedOptions={[markets[0]]}
                options={markets}
                onChange={changeMarket => this.handleChangeMarket(changeMarket[0])}
              />
              <div className='head-search' >
                <img src={SearchIcon} className='head-search-icon' onClick={this.handleSearchInput} />
                <input className='import-stock-input' placeholder={language.common_stock_code} ref={e => this.inputSearchRef = e} 
                onInput={this.handleSearchInput} onKeyDown={e => e.keyCode ===13?this.handleSearchInput() : ''} ></input>
              </div>
              {showSearchBlock && <div className='input-search' onClick={e => e.stopPropagation()} >
                {searchList?.map((item, index) => {
                  return (
                    // onClick={() => this.handleSelectStock(item.id)}
                    <div className='input-search-single' key={item.id}  >
                      <span className='input-search-single-stock' >{item.market + '.' + item.id}</span>
                      <div>
                        <span className='input-search-single-name' > {item.name} </span>
                        <img className='input-search-single-addicon' src={item.watch ? SearchWatchlistIcon : WatchlistAddIcon} onClick={item.watch? ()=>this.handleStockDelete(item,index,true) :() => this.handleLikeWatchlist(item, index)} />
                      </div>
                    </div>
                  )
                })}
              </div>}
            </div>
          </div>
          <div className='edit-stock-content'>
            <div className='stock-content-head'>
              <span className='stock-head-symbol' >{language.common_symbol}</span>
              <span className='stock-head-name' >{language.common_name}</span>
              <span className='stock-head-topping' >{language.market_topping}</span>
              <span className='stock-head-delete' >{language.common_button_delete}</span>
            </div>
            {currentGroup && currentGroup?.flaggings.map((item, index) => {
              return (
                <div className='stock-content-single' key={index} >
                  <span className='scs-symbol'>{Converter.mappingWebSocketMarket(item.market) + '.' + item.id}</span>
                  <span className='scs-name' >{item.name}</span>
                  <div className='scs-topping' onClick={() => this.handleTopping(item, index)} ><img src={topW} /></div>
                  <div className='scs-delete' onClick={() => this.handleStockDelete(item, index)} ><Icons.WatchlistDelete /> </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
  componentDidMount() {
    const { watchlist, userInfo, markets } = this.props
    let timeout =   setTimeout(() => {
      this.setState({ load: false, isLoadingConfirm: false})
    }, 6000);
    this.props.getWatchlist({ uuid: userInfo.id }, response => {
      clearTimeout(timeout)
      this.setState({ load: false, isLoadingConfirm: false })
    })
    if (markets) {
      this.setState({ currentMarket: markets[0].value })
    }
    if (watchlist.custom) {
      let sortFlaggings = watchlist.custom[0].flaggings.sort((a,b)=>{return b.weight - a.weight})
      watchlist.custom[0].flaggings = sortFlaggings
      this.setState({ currentGroup: watchlist.custom[0] })
    }
    document.addEventListener('click', this.handleDocumentClick)
  }

  componentDidUpdate() {

  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick)
  }

  handleLikeWatchlist = (searchLickStock, index) => {
    const { currentGroup, searchList } = this.state
    // this.setState({ showSearchBlock: false })
    let items = []
    items.push(searchLickStock.id + ':' + searchLickStock.market)
    if (currentGroup.flaggings) {
      currentGroup.flaggings.forEach(item => {
        items.push(item.id + ':' + item.market)
      })
    }
    const Pitem = items.join(',');
    const params = {
      [WINVEST_PARAMS_JSON_FLAG.KEY]: WINVEST_PARAMS_JSON_FLAG.VALUE,
      return: 'Y',
      data: [
        {
          name: currentGroup.name,
          items: Pitem,
        }
      ]
    }
    this.props.manageWatchList(params, res => {
      searchList[index].watch = true
      this.setState({ searchList })
      this.handleResponse(res, '', true)
    })
  }

  handleChangeMarket = (changeMarket) => {
    this.setState({ currentMarket: changeMarket.value },()=>{
      this.handleSearchInput()
    })
  }

  handleUpdateWatchlist = () => {
    const newTitle = this.inputEditRef.value
    this.setState({ load: true })
    const { currentEditItem } = this.state
    const items = []
    if (currentEditItem.flaggings) {
      currentEditItem.flaggings.forEach(item => {
        items.push(item.id + ':' + item.market)
      });
    }
    const item = items.join(',');
    const params = {
      [WINVEST_PARAMS_JSON_FLAG.KEY]: WINVEST_PARAMS_JSON_FLAG.VALUE,
      return: 'Y',
      data: [
        {
          name: currentEditItem.name,
          title: newTitle,
          items: item,
        }
      ]
    }
    this.props.manageWatchList(params, res => {
        this.handleResponse(res,'',false,true)
    })

  }

  handleDocumentClick = () => {
    if (this.inputEditRef) {
      if (this.inputEditRef.value && this.inputEditRef.value != this.state.currentEditItem.title) {
        this.handleUpdateWatchlist()
      }
    }
    this.setState({ errorMessage: '', currentEdit: -1 })
  }

  handleResponse = (res, message, addLikeWatchlist = false,updataWatch = false) => {
    let timeout = setTimeout(() => {
      this.setState({ errorMessage:'', load: false, isLoadingConfirm: false})
    }, 10000);
    if (res.status === SERVICES_RESP.STATUS_OK) {
      const { userInfo } = this.props
      this.angInputRef.value = ''
      this.props.getWatchlist({ uuid: userInfo.id }, response => {
        clearTimeout(timeout)
        this.setState({ errorMessage:'', load: false, isLoadingConfirm: false})
        if (addLikeWatchlist) {
          let currentGroup = response.result.filter(item => item.name == res.result[0].name)[0]
          let sortFlaggings =  currentGroup.flaggings.sort((a,b)=> { return b.weight - a.weight })
          currentGroup.flaggings = sortFlaggings
          this.setState({ currentGroup },()=>{
          })
        }
        if(this.props.subTabValue == this.state.currentGroup.name){
          this.props.handleRefreshTable()
        }
        if(updataWatch){  this.props.handleRefreshTable(true)}
        this.setState({ load: false, isLoadingConfirm: false, showInput: false })
      })
    } else {
      const errorMessage = res?.result ?? ''
      this.setState({ errorMessage, load: false, isLoadingConfirm: false })
    }
  }

  handleAddWatchlist() {
    const newTitle = this.angInputRef.value
    if (newTitle) {
      this.setState({ load: true, isLoadingConfirm: true })
      const { language } = this.props
      const params = {
        title: newTitle,
        ids: '',
        template: 'watchlist2'
      }
      this.props.addNewWatchlist(params, res => { this.handleResponse(res,'',false,true) })
    }
  }

  handleStockDelete(item, index,updataWatch=false) {
    let { currentGroup, searchList } = this.state
    // if(updataWatch) this.setState({  showSearchBlock: false })
    let items = currentGroup.flaggings.filter((fitem) => {
      return fitem.id != item.id
    })
    const Finalitem = []
    items.forEach(item => {
      Finalitem.push(item.id + ":" + item.market)
    })
    const Pitem = Finalitem.join(',')
    const params = {
      [WINVEST_PARAMS_JSON_FLAG.KEY]: WINVEST_PARAMS_JSON_FLAG.VALUE,
      data: [
        {
          name: currentGroup.name,
          items: Pitem,
        }
      ]
    }
    currentGroup.flaggings = items
    this.setState({ currentGroup })
    this.props.manageWatchList(params, res => {
      searchList[index].watch = false
      this.setState({ searchList })
      if(updataWatch) { 
        this.handleResponse(res, '', true)
      }else {
        this.handleResponse(res)
      }
    })
  }

  handleTopping(item, index) {
    let { currentGroup } = this.state
    currentGroup.flaggings.splice(index, 1)
    currentGroup.flaggings.unshift(item)
    this.setState({ currentGroup }, () => {
      let items = []
      if (this.state.currentGroup.flaggings) {
        this.state.currentGroup.flaggings.forEach(item => {
          items.push(item.id + ":" + item.market)
        })
        const Pitem = items.join(',');
        const params = {
          [WINVEST_PARAMS_JSON_FLAG.KEY]: WINVEST_PARAMS_JSON_FLAG.VALUE,
          data: [
            {
              name: currentGroup.name,
              items: Pitem,
            }
          ]
        }
        this.props.manageWatchList(params, res => {
          this.handleResponse(res)
        })
      }
    })
  }

  handleGruopSelect(index, item) {
    let sortFlaggings = item.flaggings.sort((a,b)=>{return b.weight - a.weight})
    item.flaggings = sortFlaggings
    this.setState({ currentGroupIndex: index, currentGroup: item })
  }

  handleEdit(e, item, index) {
    e.stopPropagation()
    this.setState({ currentEdit: index, currentEditItem: item }, () => {
      this.inputEditRef.value = item.title
    })
  }

  handleDelete(item, index) {
    const position = {
      id:'1',
      isActive:false,
      title:"common_position",
      value:"position"
    }
    if(item.name === this.props.subTabValue){
      this.props.handleChangeSubTab(position,{id:'1'})
    }
    if(item.name === this.state.currentGroup.name){
      this.setState({currentGroup:{flaggings:[]}})
    }
    this.setState({ load: true })
    const params = {
      name: item.name,
      template: 'watchlist2'
    }
    this.props.deleteWatchlist(params, res => this.handleResponse(res,'',false,true))
  }

  handleShowInput() {
    this.setState({ showInput: !this.state.showInput },()=>{
      this.angInputRef.focus()
    })
  }

  handleSearchInput = utilsFunction.debounce(() => {
    const { currentMarket } = this.state
    const { language } = this.props
    const inputValue = this.inputSearchRef.value
    const params = {
      keywords: inputValue.trim(),
      realm: 'instrument',
      language: Converter.mappingWinVestLanguage(language.lang),
      size: 50
    }
    if (inputValue) {
      this.props.searchSystemService(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK && Array.isArray(res.result?.instrument?.data) && res.result?.instrument?.data?.length) {
          const searchList = res.result.instrument.data.filter(item => item.market === currentMarket)
          let currentGroupStockID = []
          this.state.currentGroup.flaggings.forEach(item => currentGroupStockID.push(item.id))
          searchList.forEach((item, index) => {
            if (currentGroupStockID.indexOf(item.id) != -1) {
              searchList[index].watch = true
            } else {
              searchList[index].watch = false
            }
          })
          this.setState({ searchList, showSearchBlock: true })
        } else {
          this.setState({ showSearchBlock: false ,errorMessage:language.market_set_err})
        }
      })
    } else {
      this.setState({ searchList: [], showSearchBlock: false })
    }
  }, 400)
}


export default connect(
  state => ({
    language: state.app.language,
    watchlist: state.user.watchlist,
    userInfo: state.user.userInfo,
    markets: state.trade.markets,
    theme: state.app.theme,
  }),
  dispatch => ({
    addNewWatchlist: (p, c) => dispatch(userActions.addNewWatchlistAction(p, c)),
    deleteWatchlist: (p, c) => dispatch(userActions.deleteWatchlistAction(p, c)),
    getWatchlist: (p, c) => dispatch(userActions.getInstrumentWatchlistAction(p, c)),
    manageWatchList: (p, c) => dispatch(userActions.manageWatchlistAction(p, c)),

    // getQuoteHistory: (p, c) => dispatch(userActions.getQuoteHistoryAction(p, c)),
    searchSystemService: (p, res) => dispatch(forumActions.searchSystemAction(p, res)),
  }))(MarketSetDialog)